import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Package, TrendingUp, TrendingDown, History, DollarSign } from 'lucide-react';

const formatNumber = (num) => {
  if (num === undefined || num === null) return '-';
  return new Intl.NumberFormat('ro-RO').format(num);
};

const formatCurrency = (num) => {
  if (num === undefined || num === null) return '-';
  return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(num);
};

export const TraceabilityKPIs = ({ kpis }) => {
  if (!kpis) return null;

  const items = [
    { icon: Package, color: 'text-indigo-600', value: formatNumber(kpis.total_stock), label: 'Stoc Total' },
    { icon: TrendingUp, color: 'text-green-600', value: `+${formatNumber(kpis.entries_30d)}`, label: 'Intrari (30 zile)' },
    { icon: TrendingDown, color: 'text-red-600', value: `-${formatNumber(kpis.exits_30d)}`, label: 'Iesiri (30 zile)' },
    { icon: History, color: 'text-blue-600', value: formatNumber(kpis.total_movements), label: 'Total Miscari' },
    { icon: DollarSign, color: 'text-amber-600', value: formatCurrency(kpis.stock_value), label: 'Valoare Stoc' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {items.map((item, idx) => (
        <Card key={idx}>
          <CardContent className="p-4 text-center">
            <item.icon className={`w-8 h-8 ${item.color} mx-auto mb-2`} />
            <p className={`text-2xl font-bold ${idx === 1 ? 'text-green-600' : idx === 2 ? 'text-red-600' : 'text-slate-900'}`}>
              {item.value}
            </p>
            <p className="text-xs text-slate-500">{item.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
